import { render, staticRenderFns } from "./OrderInfo.vue?vue&type=template&id=39ebbd20&scoped=true&"
import script from "./OrderInfo.vue?vue&type=script&lang=ts&"
export * from "./OrderInfo.vue?vue&type=script&lang=ts&"
import style0 from "./OrderInfo.vue?vue&type=style&index=0&id=39ebbd20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ebbd20",
  null
  
)

export default component.exports